var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFillInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33203C4.32634 1.33203 1.33301 4.32536 1.33301 7.9987C1.33301 11.672 4.32634 14.6654 7.99967 14.6654C11.673 14.6654 14.6663 11.672 14.6663 7.9987C14.6663 4.32536 11.673 1.33203 7.99967 1.33203ZM7.49967 5.33203C7.49967 5.0587 7.72634 4.83203 7.99967 4.83203C8.27301 4.83203 8.49967 5.0587 8.49967 5.33203V8.66536C8.49967 8.9387 8.27301 9.16536 7.99967 9.16536C7.72634 9.16536 7.49967 8.9387 7.49967 8.66536V5.33203ZM8.61301 10.9187C8.57967 11.0054 8.53301 11.072 8.47301 11.1387C8.40634 11.1987 8.33301 11.2454 8.25301 11.2787C8.17301 11.312 8.08634 11.332 7.99967 11.332C7.91301 11.332 7.82634 11.312 7.74634 11.2787C7.66634 11.2454 7.59301 11.1987 7.52634 11.1387C7.46634 11.072 7.41967 11.0054 7.38634 10.9187C7.35301 10.8387 7.33301 10.752 7.33301 10.6654C7.33301 10.5787 7.35301 10.492 7.38634 10.412C7.41967 10.332 7.46634 10.2587 7.52634 10.192C7.59301 10.132 7.66634 10.0854 7.74634 10.052C7.90634 9.98536 8.09301 9.98536 8.25301 10.052C8.33301 10.0854 8.40634 10.132 8.47301 10.192C8.53301 10.2587 8.57967 10.332 8.61301 10.412C8.64634 10.492 8.66634 10.5787 8.66634 10.6654C8.66634 10.752 8.64634 10.8387 8.61301 10.9187Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFillInformation);
export default __webpack_public_path__ + "static/media/ic-fill-information.d97d44c36b8331744c53de5cd830dbf0.svg";
export { ForwardRef as ReactComponent };